<script setup lang="ts">
import { GeneralChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import GenericInfluxChart from '@/composables/charts/GenericInfluxChart.vue'
import { ANNOTATOR_TYPES } from '@/composables/charts/influx-charts/ChartIncidentAnnotators'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { RegionSumInfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/RegionSumChartBuilder'
withDefaults(
  defineProps<{
    synchronizationKey?: string
    fixedTimeResolution?: number
    days?: number
  }>(),
  {
    fixedTimeResolution: undefined,
    days: 7,
    synchronizationKey: undefined,
  }
)
</script>

<template>
  <GenericInfluxChart
    :chart-builder="
      new RegionSumInfluxChartBuilder({
        chartType: CHART_TYPES.REGION_SUMS,
        field: 'meanCount',
        xAggregation: 'mean',
        timeSetup: GeneralChartTimeSetup.lastNDays(days, synchronizationKey, fixedTimeResolution).serialize(),
        title: $t('charts.titles.labelCounts'),
        subtitle: $t('charts.subtitles.labelCountsGlobal'),
        incidentAnnotators: [{ annotatorType: ANNOTATOR_TYPES.BARNDOC }, { annotatorType: ANNOTATOR_TYPES.SPARSE_DICT_ANOMALY }],
        incidentReducer: { reducerType: 'penState' },
        regionSumProperty: 'label',
        regionSumValueTagSelector: { tag: 'value', groupByValues: true, useAll: true, allowEmptyValues: false },
      })
    "
  ></GenericInfluxChart>
</template>

<style scoped></style>
